import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { FileDto } from "@green0meter/api-client";

import { DOMAIN_AI } from "../domain";

import { fileApi } from "@api/services";
import { getMimeTypeFromExtension } from "@helpers";

export const ACTION_UPLOAD_FILE = "UPLOAD_FILE";

interface UploadFileRequest {
  file: FileDto;
}

interface UploadFileResponse {
  success: boolean;
  message?: string;
  error?: string;
}

const uploadFile = async (
  request: UploadFileRequest,
): Promise<UploadFileResponse> => {
  try {
    const response = await fileApi.fileStorageControllerDownloadFile(
      request.file.pathName,
      {
        responseType: "blob",
      },
    );

    const fileBlob = response.data;

    const realFile = new File([fileBlob], request.file.name, {
      type: getMimeTypeFromExtension(request.file.name),
    });

    const formData = new FormData();

    formData.append("data", realFile, request.file.name);
    formData.append("fileId", request.file.id);

    const requestOptions = {
      method: "POST",
      body: formData,
      redirect: "follow" as RequestRedirect,
    };

    const webhookResponse = await fetch(
      "https://greenometer.app.n8n.cloud/webhook/850a1ca2-831f-42df-bcec-c37a719946ca",
      requestOptions,
    );

    const result = await webhookResponse.text();

    return {
      success: true,
      message: result,
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};

export const useUploadFile = (): UseMutationResult<
  UploadFileResponse,
  Error,
  UploadFileRequest
> => {
  return useMutation<UploadFileResponse, Error, UploadFileRequest>({
    mutationKey: [DOMAIN_AI, ACTION_UPLOAD_FILE],
    mutationFn: uploadFile,
  });
};
